import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/license/',
    component: ComponentCreator('/license/', 'bbd'),
    exact: true
  },
  {
    path: '/search/',
    component: ComponentCreator('/search/', '21e'),
    exact: true
  },
  {
    path: '/',
    component: ComponentCreator('/', 'e5f'),
    exact: true
  },
  {
    path: '/',
    component: ComponentCreator('/', 'ac1'),
    routes: [
      {
        path: '/0.1.6/',
        component: ComponentCreator('/0.1.6/', 'df6'),
        routes: [
          {
            path: '/0.1.6/',
            component: ComponentCreator('/0.1.6/', '329'),
            routes: [
              {
                path: '/0.1.6/develop/contributing/',
                component: ComponentCreator('/0.1.6/develop/contributing/', 'd1f'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/0.1.6/develop/contributing/commands/',
                component: ComponentCreator('/0.1.6/develop/contributing/commands/', '5dc'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/0.1.6/develop/contributing/ide-setup/',
                component: ComponentCreator('/0.1.6/develop/contributing/ide-setup/', '80c'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/0.1.6/develop/java/',
                component: ComponentCreator('/0.1.6/develop/java/', 'a99'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/0.1.6/develop/javadoc/',
                component: ComponentCreator('/0.1.6/develop/javadoc/', '2d2'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/0.1.6/learn/',
                component: ComponentCreator('/0.1.6/learn/', '4bb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.1.6/learn/docker/',
                component: ComponentCreator('/0.1.6/learn/docker/', '9ad'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.1.6/learn/docker/cli/',
                component: ComponentCreator('/0.1.6/learn/docker/cli/', 'c8b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.1.6/learn/language/',
                component: ComponentCreator('/0.1.6/learn/language/', 'e83'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.1.6/learn/language/classes/',
                component: ComponentCreator('/0.1.6/learn/language/classes/', 'b3c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.1.6/learn/language/logic/',
                component: ComponentCreator('/0.1.6/learn/language/logic/', 'fc1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.1.6/learn/language/predicates/',
                component: ComponentCreator('/0.1.6/learn/language/predicates/', '2b8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.1.6/learn/tutorials/',
                component: ComponentCreator('/0.1.6/learn/tutorials/', '05c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.1.6/learn/tutorials/dlt/',
                component: ComponentCreator('/0.1.6/learn/tutorials/dlt/', '6b1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.1.6/learn/tutorials/file-system/',
                component: ComponentCreator('/0.1.6/learn/tutorials/file-system/', 'fe7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.1.6/learn/tutorials/project/',
                component: ComponentCreator('/0.1.6/learn/tutorials/project/', '23c'),
                exact: true,
                sidebar: "learnSidebar"
              }
            ]
          }
        ]
      },
      {
        path: '/0.2.0/',
        component: ComponentCreator('/0.2.0/', '474'),
        routes: [
          {
            path: '/0.2.0/',
            component: ComponentCreator('/0.2.0/', 'df9'),
            routes: [
              {
                path: '/0.2.0/develop/contributing/',
                component: ComponentCreator('/0.2.0/develop/contributing/', '779'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/0.2.0/develop/contributing/commands/',
                component: ComponentCreator('/0.2.0/develop/contributing/commands/', 'f65'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/0.2.0/develop/contributing/ide-setup/',
                component: ComponentCreator('/0.2.0/develop/contributing/ide-setup/', '972'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/0.2.0/develop/java/',
                component: ComponentCreator('/0.2.0/develop/java/', 'cc9'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/0.2.0/develop/javadoc/',
                component: ComponentCreator('/0.2.0/develop/javadoc/', 'cca'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/0.2.0/learn/',
                component: ComponentCreator('/0.2.0/learn/', '36a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.2.0/learn/docker/',
                component: ComponentCreator('/0.2.0/learn/docker/', 'a61'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.2.0/learn/docker/cli/',
                component: ComponentCreator('/0.2.0/learn/docker/cli/', 'a4d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.2.0/learn/language/',
                component: ComponentCreator('/0.2.0/learn/language/', '5a4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.2.0/learn/language/classes/',
                component: ComponentCreator('/0.2.0/learn/language/classes/', 'a89'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.2.0/learn/language/logic/',
                component: ComponentCreator('/0.2.0/learn/language/logic/', '325'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.2.0/learn/language/predicates/',
                component: ComponentCreator('/0.2.0/learn/language/predicates/', 'bdd'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.2.0/learn/tutorials/',
                component: ComponentCreator('/0.2.0/learn/tutorials/', 'e7f'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.2.0/learn/tutorials/dlt/',
                component: ComponentCreator('/0.2.0/learn/tutorials/dlt/', '4c8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.2.0/learn/tutorials/file-system/',
                component: ComponentCreator('/0.2.0/learn/tutorials/file-system/', '52d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/0.2.0/learn/tutorials/project/',
                component: ComponentCreator('/0.2.0/learn/tutorials/project/', 'b10'),
                exact: true,
                sidebar: "learnSidebar"
              }
            ]
          }
        ]
      },
      {
        path: '/snapshot/',
        component: ComponentCreator('/snapshot/', '125'),
        routes: [
          {
            path: '/snapshot/',
            component: ComponentCreator('/snapshot/', 'ebc'),
            routes: [
              {
                path: '/snapshot/develop/contributing/',
                component: ComponentCreator('/snapshot/develop/contributing/', '030'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/snapshot/develop/contributing/commands/',
                component: ComponentCreator('/snapshot/develop/contributing/commands/', 'ca6'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/snapshot/develop/contributing/ide-setup/',
                component: ComponentCreator('/snapshot/develop/contributing/ide-setup/', '284'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/snapshot/develop/java/',
                component: ComponentCreator('/snapshot/develop/java/', '186'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/snapshot/develop/javadoc/',
                component: ComponentCreator('/snapshot/develop/javadoc/', '435'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/snapshot/learn/',
                component: ComponentCreator('/snapshot/learn/', '48b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/snapshot/learn/docker/',
                component: ComponentCreator('/snapshot/learn/docker/', '8d2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/snapshot/learn/docker/cli/',
                component: ComponentCreator('/snapshot/learn/docker/cli/', '3ec'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/snapshot/learn/language/',
                component: ComponentCreator('/snapshot/learn/language/', '6b4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/snapshot/learn/language/classes/',
                component: ComponentCreator('/snapshot/learn/language/classes/', 'b6a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/snapshot/learn/language/logic/',
                component: ComponentCreator('/snapshot/learn/language/logic/', '203'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/snapshot/learn/language/predicates/',
                component: ComponentCreator('/snapshot/learn/language/predicates/', 'dbf'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/snapshot/learn/tutorials/',
                component: ComponentCreator('/snapshot/learn/tutorials/', 'fae'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/snapshot/learn/tutorials/dlt/',
                component: ComponentCreator('/snapshot/learn/tutorials/dlt/', 'f94'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/snapshot/learn/tutorials/file-system/',
                component: ComponentCreator('/snapshot/learn/tutorials/file-system/', '4d4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/snapshot/learn/tutorials/project/',
                component: ComponentCreator('/snapshot/learn/tutorials/project/', '43e'),
                exact: true,
                sidebar: "learnSidebar"
              }
            ]
          }
        ]
      },
      {
        path: '/',
        component: ComponentCreator('/', '40f'),
        routes: [
          {
            path: '/',
            component: ComponentCreator('/', 'cb7'),
            routes: [
              {
                path: '/develop/contributing/',
                component: ComponentCreator('/develop/contributing/', '7ef'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/develop/contributing/commands/',
                component: ComponentCreator('/develop/contributing/commands/', '349'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/develop/contributing/ide-setup/',
                component: ComponentCreator('/develop/contributing/ide-setup/', '6d3'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/develop/java/',
                component: ComponentCreator('/develop/java/', '0e1'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/develop/javadoc/',
                component: ComponentCreator('/develop/javadoc/', 'cca'),
                exact: true,
                sidebar: "developSidebar"
              },
              {
                path: '/learn/',
                component: ComponentCreator('/learn/', '9c1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/learn/docker/',
                component: ComponentCreator('/learn/docker/', 'df7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/learn/docker/cli/',
                component: ComponentCreator('/learn/docker/cli/', '03b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/learn/language/',
                component: ComponentCreator('/learn/language/', '7ca'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/learn/language/classes/',
                component: ComponentCreator('/learn/language/classes/', 'e07'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/learn/language/logic/',
                component: ComponentCreator('/learn/language/logic/', '4d6'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/learn/language/predicates/',
                component: ComponentCreator('/learn/language/predicates/', '4af'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/learn/tutorials/',
                component: ComponentCreator('/learn/tutorials/', 'ebd'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/learn/tutorials/dlt/',
                component: ComponentCreator('/learn/tutorials/dlt/', 'dde'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/learn/tutorials/file-system/',
                component: ComponentCreator('/learn/tutorials/file-system/', '18e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/learn/tutorials/project/',
                component: ComponentCreator('/learn/tutorials/project/', '847'),
                exact: true,
                sidebar: "learnSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
